import React from 'react';
import { StatusType } from '../../api/api.types';
import { WithTranslation, withTranslation } from 'react-i18next';

interface StatusLabelProps extends WithTranslation {
  status: StatusType;
}

class StatusLabel extends React.PureComponent<StatusLabelProps> {

  getStatusLabel(status: StatusType) {
    const { t } = this.props;

    switch (status) {
      case StatusType.ACTIVE:
        return t('components.status_label.active');
      case StatusType.INACTIVE:
        return t('components.status_label.inactive');
      case StatusType.DELETED:
        return t('components.status_label.deleted');
      case StatusType.EXPIRED:
        return t('components.status_label.expired');
      default:
        return status;
    }
  }

  render() {
    return (
      <div className={this.props.status === 'ACTIVE' ? 'text-success' : 'text-secondary'}>
        {this.getStatusLabel(this.props.status)}
      </div>
    );
  }
}

export default withTranslation()(StatusLabel);
